export default "__VITE_ASSET__BxhDDq87__"